import { EventBus } from "../../../eventbus";

import { baseUrl } from "../../../config.js";
import { thumbnail, placeholderThumb } from "../../../functions/thumbnail";

export default {
  /*
      Defines the data used by the component
    */
  data() {
    return {
      user: this.$store.state.user,
      search: this.$route.params.query,
      results: null,
      company: this.$store.state.company,
      company_full: this.$store.state.company_full,
      axiosLoaded: false,
      size: null,
      latestRequest: false,
      onlyPartials: false,
      canShow: false,
      timeout: null,
      searching: false,
    };
  },
  created() {
    if (this.search) {
      if (this.$router.currentRoute.name === "Search") {
        this.searchIt(false);
      } else {
        this.searchIt(true);
      }
    }

    EventBus.$on("search", (term) => {
      this.search = term;
      this.searchIt(true);
    });
  },

  methods: {
    debounce(callback, wait) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        callback();
      }, wait);
    },
    searchIt(shouldOpen, event) {
      if (event) {
        if (event.keyCode == 13) {
          this.goFull();
          return;
        }
      }

      this.debounce(() => {
        // code you would like to run 1000ms after the keyup event has stopped firing
        // further keyup events reset the timer, as expected
        this.searchItExecute(shouldOpen, event);
      }, 1000);
    },
    thumb(item) {
      return thumbnail(item);
    },
    onError() {
      return placeholderThumb();
    },
    searchItExecute(shouldOpen, event) {
      if (event) {
        if (event.keyCode == 13) {
          this.goFull();
          return;
        }
      }

      if (this.search === "") {
        this.searching = false;
        this.canShow = false;
        this.axiosLoaded = false;
        this.results = null;
        this.size = null;
      } else {
        this.searching = true;
        this.axiosLoaded = false;
        this.latestRequest = Math.random();
        let requestId = this.latestRequest;
        let uri = baseUrl + "/searchv2?q=" + this.search;

        if (this.user) {
          uri += "&key=" + this.user.key;
        }
        this.$axios
          .get(uri)
          .then((response) => {
            this.searching = false;
            if (requestId != this.latestRequest) {
              //error?
            } else {
              if (Object.keys(response.data.result).length) {
                this.canShow = shouldOpen;
                this.results = response.data.result;
                this.onlyPartials = response.data.partials;
                this.size = response.data.size;
              } else {
                this.size = 0;
                this.results = null;
                this.canShow = shouldOpen;
                this.onlyPartials = false;
              }

              this.$store.state.isLoading = false;
              this.axiosLoaded = true;
            }
          })
          .catch((e) => {
            this.searching = false;
          });
      }
    },
    closeSearch() {
      this.size = null;
      this.results = null;
      this.search = "";
      this.axiosLoaded = false;
    },
    goFull() {
      this.$router.push(
        "/" + this.$store.state.company + "/search/" + this.search
      );
      this.canShow = false;
      this.$router.go();
    },

    goFolder(id, myspace) {
      this.closeSearch();

      this.$router.push(
        `/${this.$store.state.company}/${
          myspace ? "myspace" : "home"
        }/expanded/${id}`
      );
    },
    goFile(folder, id, myspace) {
      this.closeSearch();

      this.$router.push(
        `/${this.$store.state.company}/${
          myspace ? "myspace" : "home"
        }/expanded/${folder}/${id}`
      );
    },
  },
  computed: {
    resultLength: function () {
      return this.size;
    },
    emptyAgain: function () {
      return this.search === "";
    },
    resultsHasItems() {
      let hasItems = false;

      if (this.results) {
        Object.keys(this.results).forEach((key) => {
          const group = this.results[key];

          if (group.list) {
            if (group.list.length) {
              hasItems = true;
            }
          }
        });
      }

      return hasItems;
    },
  },

  watch: {
    $route() {
      if (!this.$route.path.includes("/search")) {
        this.closeSearch();
      }
    },
  },
};
